import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type GaPaidUserFragment = (
  { __typename: 'Member' }
  & Pick<Types.Member, 'id'>
  & { organizations: Array<(
    { __typename: 'Organization' }
    & Pick<Types.Organization, 'id' | 'offering'>
  )> }
);

export const GaPaidUserFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GaPaidUser' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'offering' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseGaPaidUserFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<GaPaidUserFragment, Apollo.OperationVariables>,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseGaPaidUserFragmentResult
  extends Omit<Apollo.UseFragmentResult<GaPaidUserFragment>, 'data'> {
  data?: GaPaidUserFragment;
}

export const useGaPaidUserFragment = ({
  from,
  returnPartialData,
  ...options
}: UseGaPaidUserFragmentOptions): UseGaPaidUserFragmentResult => {
  const result = Apollo.useFragment<GaPaidUserFragment>({
    ...options,
    fragment: GaPaidUserFragmentDoc,
    fragmentName: 'GaPaidUser',
    from: {
      __typename: 'Member',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as GaPaidUserFragment };
};
